import { Checkbox } from "antd";
import { debounce } from "debounce";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FILTER_ID } from ".";
import LoadingBox from "../../../components/LoadingBox";
import { selectOneSetting } from "../../../util/store/selectors";
import { selectSite } from "../../../util/store/site/constants";
import { productionAreas } from "../../../util/varibles/constants";
import { getProdAreaName, renderOpts } from "../../../util/varibles/global";
import { SiteOverviewSetting } from "../../../util/varibles/userSetting";
import { loginActions } from "../../LoginPage/reducer";
import { callEventSiteOverview, useSiteOverview } from "../SiteOverviewContext";

const ProductionAreas = () => {
    const [value, setValue] = useState<string[] | undefined>(undefined);
    const filter = useSelector(selectOneSetting(SiteOverviewSetting.UNITS_PROD_AREA_FILTER));
    const proAreas = useSelector(selectSite.proAreas);
    const loading = useSelector(selectSite.loading);
    const [call] = useSiteOverview(state => state.unitsFilter[FILTER_ID.PROD_AREAS]);
    const { addUnitsFilter, removeUnitsFilter } = callEventSiteOverview();
    const dispatch = useDispatch();

    const timeout = useRef(debounce((value: string[]) => {
        if (value.length === 0) {
            removeUnitsFilter(FILTER_ID.PROD_AREAS);
        } else {
            const ids = new Set(value);
            addUnitsFilter({ [FILTER_ID.PROD_AREAS]: data => ids.has(data.site.prod_area || "") })
        }
        dispatch(loginActions.updateUserSetting([{ [SiteOverviewSetting.UNITS_PROD_AREA_FILTER]: value }]))
    }, 350));

    useEffect(() => {
        if (call === undefined) {
            setValue([]);
        }
    }, [call]);


    const opts = useMemo(() => productionAreas.filter(item => proAreas.has(item.id)).map(item => ({
        ...item,
        name: getProdAreaName(item)
    })), [proAreas]);

    const handleChange = (value: string[]) => {
        setValue(value);
        timeout.current(value);
    }

    return <>
        <div className="mb-2" data-lev='title'>
            Production areas
        </div>
        {(loading || opts.length === 0) && <LoadingBox className="mt-3" loading={loading} />}
        <Checkbox.Group
            className='checkbox-fill gap-y-[8px]'
            value={value || filter || []}
            onChange={handleChange}
            options={renderOpts(opts)}
        />
    </>
}

export default ProductionAreas;